export const environment = {
  production: true,
  buildId: '2972588498419851',
  configFile: 'config.json',
};
